import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid, Label } from 'semantic-ui-react';
import { providersActions } from '../../actions/providers.actions';

class ProviderTypeEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(providersActions.getTypeById(match.params.id)).then(() => {
      const { providers } = this.props;
      this.setState({
        name: providers.name,
      });
    });
  }

  handleChange(e, data) {
    if (data) {
      this.setState({ [data.name]: data.value });
    } else {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { dispatch, match } = this.props;
    const { name } = this.state;
    if (name) {
      dispatch(
        providersActions.updateType(
          match.params.id,
          {
            name,
          },
          this.props.history,
        ),
      );
    }
  }

  render() {
    const { name, submitted } = this.state;
    const { loading } = this.props;

    return (
      <Fragment>
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <h1>Editar Tipo de Fornecedor</h1>
          </Grid.Column>
        </Grid>
        <Form onSubmit={this.handleSubmit} loading={loading}>
          <Form.Field>
            <label>Nome</label>
            <input
              name="name"
              placeholder="Nome do Tipo"
              value={name}
              onChange={this.handleChange}
            />
            {submitted && !name && (
              <Label basic color="red" pointing>
                Nome é requerido
              </Label>
            )}
          </Form.Field>
          <Button primary type="submit">
            Atualizar
          </Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { providers } = state;
  return {
    providers: providers.item,
    loading: providers.loading || false,
  };
}

const connectedProviderTypeEditScreen = connect(mapStateToProps)(ProviderTypeEditScreen);
export { connectedProviderTypeEditScreen as ProviderTypeEditScreen };
